export default function DownloadCTA() {
  return (
    <section id="download" className="relative overflow-hidden bg-background-100 py-20 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-500 via-accent-500 to-secondary-400 px-6 py-12 md:px-14 md:py-16">
          <div className="pointer-events-none absolute -right-10 -top-10 h-48 w-48 rounded-full bg-white/10 blur-2xl" />
          <div className="pointer-events-none absolute -bottom-12 -left-8 h-56 w-56 rounded-full bg-white/10 blur-2xl" />

          <div className="relative grid items-center gap-8 lg:grid-cols-2">
            <div>
              <h2 className="font-heading text-2xl leading-tight text-background-50 md:text-4xl">
                现在下载，开启你的
                <br />
                随时畅读之旅
              </h2>
              <p className="mt-4 max-w-md text-base text-white/90">
                离线阅读、智能缓存、订阅收藏全部支持。电脑版、手机版一键下载，
                随时随地想看就看。
              </p>
            </div>

            <div className="flex flex-col gap-3 sm:flex-row lg:justify-end">
              <a
                href="#download"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-base font-semibold text-accent-700 transition-transform hover:-translate-y-0.5"
              >
                <i className="ri-apple-line text-xl" />
                iOS 下载
              </a>
              <a
                href="#download"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-base font-semibold text-accent-700 transition-transform hover:-translate-y-0.5"
              >
                <i className="ri-android-line text-xl" />
                Android 下载
              </a>
              <a
                href="#download"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border-2 border-white/60 px-6 py-3 text-base font-medium text-background-50 transition-colors hover:bg-white/10"
              >
                <i className="ri-windows-line text-xl" />
                电脑版
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}